import { useState } from "react";
import { Search, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const FilterBar = ({ search, setSearch, children, testid = "filter-bar" }) => (
  <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center" data-testid={testid}>
    <div className="relative sm:w-80">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search…" className="h-10 bg-white pl-9" data-testid={`${testid}-search-input`} />
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Pill = ({ active, onClick, children, testid }) => (
  <button onClick={onClick} data-testid={testid} className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${active ? "border-[#123634] bg-[#123634] text-white" : "border-slate-300 bg-white text-slate-600 hover:border-slate-500"}`}>
    {children}
  </button>
);

export const useQueryPath = (base, params) => {
  const q = Object.entries(params).filter(([, v]) => v && v !== "all").map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
  return q ? `${base}?${q}` : base;
};

export const ExportButton = ({ path, filename, testid }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={go} disabled={busy} className="btn-outline" data-testid={testid}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Export to Excel (CSV)
    </button>
  );
};
